import React,{useState} from 'react';
import {Link} from 'react-scroll';
import logo from '../images/images2/logoLago.png';

function Navbar() {

    const[nav,setnav] = useState(false);

    const changeBackground = () => {
        if(window.scrollY >= 50){
            setnav(true);
        }
        else{
            setnav(false);
        }
    }

    window.addEventListener('scroll',changeBackground);

    return (
        <nav className={nav ? "nav active" :"nav"}>
            <Link to='main' className='logo' smooth={true} duration={2000}>
                <img src={logo} alt=''/>
            </Link>
            <input className='menu-btn' type='checkbox' id='menu-btn'/>
            <label className='menu-icon' for='menu-btn'>
                <span className='nav-icon'></span>
            </label>
            <ul className='menu'>
                <li><Link to="main" smooth={false} duration={2000}>Inicio</Link></li>
                <li><Link to="products" smooth={false} duration={2000}>Servicios</Link></li>
                <li><Link to="about" smooth={false} duration={2000}>Horario y Rutas</Link></li>
                <li><Link to="contact" smooth={false} duration={2000}>Sobre Nosotros</Link></li>
                <li><Link to='footer' smooth={false} duration={2000}>Contacto</Link></li>
            </ul>
        </nav>
    )
}

export default Navbar;
